module.exports = __webpack_public_path__ + "static/media/matthias-karadar.a1ca6226.jpg";